import React, { useState, useEffect, useRef, useCallback } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// ═══════════════════════════════════════════════════════════════
// COMPANY BRANDING
// ═══════════════════════════════════════════════════════════════
const COMPANY_CONFIG = {
  logoUrl: 'https://z-cdn-media.chatglm.cn/files/86bfe366-0a29-48c9-b8eb-e0fa3bef5bd0.png?auth_key=1884647840-79f02290097b4449896bd34eec18e7c1-0-ec693e56f6bf8ed854ded6e05bb124d4',
  name: 'FlexBoost',
  fullName: 'FlexBoost International Ltd',
  tagline: 'Your Growth Matters',
  primaryColor: '#2563eb',
};

// ═══════════════════════════════════════════════════════════════
// SVG ICONS
// ═══════════════════════════════════════════════════════════════
const Ic = ({ children, size = 18, sw = 1.7 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={sw}
    strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

const ic = {
  dashboard: <Ic><path d="M4 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM14 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4zM14 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z"/></Ic>,
  leads: <Ic><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></Ic>,
  clients: <Ic><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></Ic>,
  applications: <Ic><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6"/><path d="M16 13H8M16 17H8M10 9H8"/></Ic>,
  loans: <Ic><path d="M12 2v20M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6"/></Ic>,
  products: <Ic><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></Ic>,
  recordPay: <Ic><path d="M12 1v22M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6"/></Ic>,
  history: <Ic><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></Ic>,
  mpesa: <Ic><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><path d="M12 18h.01"/></Ic>,
  link: <Ic><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></Ic>,
  collections: <Ic><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"/><rect x="9" y="3" width="6" height="4" rx="1"/><path d="M9 14l2 2 4-4"/></Ic>,
  performance: <Ic><path d="M18 20V10M12 20V4M6 20v-6"/></Ic>,
  comms: <Ic><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 2v3a2 2 0 01-2 2h-.07a18.37 18.37 0 006.58 6.58"/></Ic>,
  users: <Ic><path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/></Ic>,
  branches: <Ic><path d="M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11M20 10v11M8 14v3M12 14v3M16 14v3"/></Ic>,
  audit: <Ic><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></Ic>,
  reports: <Ic><path d="M18 20V10M12 20V4M6 20v-6"/><path d="M2 20h20"/></Ic>,
  profile: <Ic><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></Ic>,
  logout: <Ic><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></Ic>,
  // NEW: Return/undo icon for returned profiles
  returnIcon: <Ic><polyline points="9 14 4 9 9 4"/><path d="M20 20v-7a4 4 0 00-4-4H4"/></Ic>,
};

const ChevronIcon = ({ open }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5"
    strokeLinecap="round" strokeLinejoin="round"
    style={{
      transition: 'transform 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
      flexShrink: 0,
    }}>
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const CollapseIcon = ({ collapsed }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2"
    strokeLinecap="round" strokeLinejoin="round"
    style={{
      transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)',
    }}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

// ═══════════════════════════════════════════════════════════════
// MENU STRUCTURE
// ═══════════════════════════════════════════════════════════════
const menuConfig = {
  standalone: [
    { path: '/', label: 'Dashboard', icon: ic.dashboard, module: 'dashboard' },
  ],
  sections: [
    {
      id: 'sales', label: 'Sales & Client Management', icon: ic.leads,
      items: [
        { path: '/leads', label: 'Lead Pipeline', icon: ic.leads, module: 'leads' },
        { path: '/clients', label: 'Client Portfolio', icon: ic.clients, module: 'clients' },
        // ═══════════════════════════════════════════════════════════
        // NEW: Returned profiles menu item
        // ═══════════════════════════════════════════════════════════
        { path: '/clients/returned', label: 'Returned Profiles', icon: ic.returnIcon, module: 'clients' },
      ],
    },
    {
      id: 'loans', label: 'Loan Operations', icon: ic.loans,
      items: [
        { path: '/loans/applications', label: 'Applications', icon: ic.applications, module: 'loans' },
        { path: '/loans/active', label: 'Active Loans', icon: ic.loans, module: 'loans' },
        { path: '/products', label: 'Loan Products', icon: ic.products, module: 'loan-products' },
      ],
    },
    {
      id: 'payments', label: 'Payments & Collections', icon: ic.recordPay,
      items: [
        { path: '/repayments/new', label: 'Record Payment', icon: ic.recordPay, module: 'repayments' },
        { path: '/repayments/history', label: 'Transaction History', icon: ic.history, module: 'repayments' },
      ],
    },
    {
      id: 'mpesa', label: 'Mobile Money', icon: ic.mpesa,
      items: [
        { path: '/mpesa', label: 'M-Pesa Transactions', icon: ic.mpesa, module: 'repayments' },
        { path: '/mpesa/link-code', label: 'Link Codes', icon: ic.link, module: 'repayments' },
      ],
    },
    {
      id: 'collections', label: 'Collections', icon: ic.collections,
      items: [
        { path: '/collections', label: 'Collection Dashboard', icon: ic.collections, module: 'collections' },
        { path: '/collections/performance', label: 'Performance Analytics', icon: ic.performance, module: 'collections' },
      ],
    },
    {
      id: 'comms', label: 'Communications', icon: ic.comms,
      items: [
        { path: '/communications', label: 'Messages & Alerts', icon: ic.comms, module: 'communications' },
        { path: '/communications/interactions', label: 'Client Interactions', icon: ic.comms, module: 'communications' },
      ],
    },
    {
      id: 'admin', label: 'System Administration', icon: ic.users,
      roles: ['Admin', 'General Manager', 'IT Admin', 'Auditor'],
      items: [
        { path: '/admin/users', label: 'User Management', icon: ic.users },
        { path: '/admin/branches', label: 'Branch Network', icon: ic.branches },
        { path: '/admin/audit-logs', label: 'Audit Trail', icon: ic.audit },
        { path: '/reports', label: 'Reports & Analytics', icon: ic.reports },
      ],
    },
  ],
};

export default function Sidebar({ collapsed, mobileOpen, onCloseMobile, onToggleCollapsed }) {
  const { user, hasPermission, loading, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const [openSections, setOpenSections] = useState({});
  const contentRefs = useRef({});

  useEffect(() => {
    if (loading) return;
    const path = location.pathname;
    for (const s of menuConfig.sections) {
      if (s.items.some(i => path === i.path || (i.path !== '/' && path.startsWith(i.path)))) {
        setOpenSections(p => ({ ...p, [s.id]: true }));
      }
    }
  }, [location.pathname, loading]);

  const toggleSection = useCallback((id) => {
    setOpenSections(p => ({ ...p, [id]: !p[id] }));
  }, []);

  const isSectionVisible = useCallback((s) => {
    if (s.roles && !s.roles.includes(user?.role?.name)) return false;
    return s.items.some(i => !i.module || hasPermission(i.module, 'view'));
  }, [user, hasPermission]);

  const getPermittedItems = useCallback((s) => {
    return s.items.filter(i => !i.module || hasPermission(i.module, 'view'));
  }, [hasPermission]);

  const goToProfile = useCallback(() => {
    navigate('/profile');
    onCloseMobile();
  }, [navigate, onCloseMobile]);

  return (
    <>
      <style>{`
        /* ═══════════════════════════════════════════════════════
           COMPACT PROFESSIONAL SIDEBAR (260px)
           ═══════════════════════════════════════════════════════ */
        .sb {
          position: fixed;
          top: 0;
          left: 0;
          height: 100vh;
          background: linear-gradient(180deg, #0f172a 0%, #1e293b 100%);
          z-index: 100;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          width: 260px;
          box-shadow: 4px 0 24px rgba(0, 0, 0, 0.15);
          border-right: 1px solid rgba(255, 255, 255, 0.05);
        }
        .sb.collapsed {
          width: 70px;
        }

        .sb-brand {
          display: flex;
          align-items: center;
          padding: 16px 16px 14px;
          flex-shrink: 0;
          gap: 12px;
          overflow: hidden;
          position: relative;
          background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, transparent 100%);
          border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        }

        .sb-logo-img {
          width: 40px;
          height: 40px;
          object-fit: contain;
          flex-shrink: 0;
          filter: drop-shadow(0 2px 4px rgba(37, 99, 235, 0.3));
          transition: transform 0.2s ease;
        }

        .sb-brand-info {
          overflow: hidden;
          white-space: nowrap;
          display: flex;
          flex-direction: column;
          gap: 1px;
        }
        .sb-brand-name {
          font-size: 15px;
          font-weight: 700;
          color: #f8fafc;
          letter-spacing: -0.5px;
          line-height: 1.2;
          background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .sb-brand-fullname {
          font-size: 10px;
          color: #94a3b8;
          font-weight: 500;
          letter-spacing: 0.2px;
          line-height: 1.2;
        }
        .sb-brand-tagline {
          font-size: 9px;
          color: #f59e0b;
          font-weight: 600;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          margin-top: 1px;
          opacity: 0.9;
        }

        .sb-close {
          display: none;
          position: absolute;
          top: 14px;
          right: 12px;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
          color: #94a3b8;
          cursor: pointer;
          padding: 5px;
          border-radius: 6px;
          transition: all 0.15s;
        }
        .sb-close:hover {
          background: rgba(255, 255, 255, 0.1);
          color: #e2e8f0;
        }

        .sb-nav {
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 10px 10px 16px;
          scrollbar-width: thin;
          scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
        }
        .sb-nav::-webkit-scrollbar { width: 4px; }
        .sb-nav::-webkit-scrollbar-track { background: transparent; }
        .sb-nav::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.1); border-radius: 4px; }

        .sb-lnk {
          display: flex;
          align-items: center;
          gap: 11px;
          padding: 9px 12px;
          margin: 2px 0;
          border-radius: 8px;
          color: #cbd5e1;
          text-decoration: none;
          font-size: 13px;
          font-weight: 500;
          transition: all 0.2s ease;
          cursor: pointer;
          position: relative;
          border: 1px solid transparent;
        }
        .sb-lnk:hover {
          background: rgba(255, 255, 255, 0.05);
          color: #f1f5f9;
        }
        .sb-lnk.active {
          background: linear-gradient(135deg, rgba(37, 99, 235, 0.15) 0%, rgba(37, 99, 235, 0.08) 100%);
          color: #93c5fd;
          border-color: rgba(37, 99, 235, 0.3);
        }
        .sb-lnk-ic {
          width: 18px;
          height: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          opacity: 0.6;
          transition: opacity 0.2s;
        }
        .sb-lnk:hover .sb-lnk-ic { opacity: 0.85; }
        .sb-lnk.active .sb-lnk-ic { opacity: 1; }
        .sb-lnk-txt { overflow: hidden; white-space: nowrap; }

        .sb-sec { margin-top: 6px; }
        .sb-sec-hdr {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 7px 12px;
          border-radius: 8px;
          cursor: pointer;
          color: #64748b;
          font-size: 9.5px;
          font-weight: 600;
          letter-spacing: 0.8px;
          text-transform: uppercase;
          transition: all 0.2s ease;
          user-select: none;
          border: none;
          background: none;
          width: 100%;
          text-align: left;
          font-family: inherit;
        }
        .sb-sec-hdr:hover {
          background: rgba(255, 255, 255, 0.03);
          color: #94a3b8;
        }
        .sb-sec-hdr.open { color: #94a3b8; }
        .sb-sec-ic {
          width: 16px;
          height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .sb-sec-txt { flex: 1; overflow: hidden; white-space: nowrap; }
        .sb-sec-chev {
          display: flex;
          align-items: center;
          color: #475569;
        }

        .sb-sec-body {
          overflow: hidden;
          transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.2s ease;
        }
        .sb-sec-body.shut { max-height: 0 !important; opacity: 0; }
        .sb-sec-inner { padding: 2px 0 4px; }

        .sb-ch {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 7px 12px 7px 38px;
          margin: 1px 0;
          border-radius: 8px;
          color: #94a3b8;
          text-decoration: none;
          font-size: 12.5px;
          font-weight: 450;
          transition: all 0.2s ease;
          cursor: pointer;
          border: 1px solid transparent;
        }
        .sb-ch:hover {
          background: rgba(255, 255, 255, 0.05);
          color: #e2e8f0;
        }
        .sb-ch.active {
          background: linear-gradient(135deg, rgba(37, 99, 235, 0.15) 0%, rgba(37, 99, 235, 0.08) 100%);
          color: #93c5fd;
          border-color: rgba(37, 99, 235, 0.3);
        }
        .sb-ch-ic {
          width: 16px;
          height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          opacity: 0.5;
          transition: opacity 0.2s;
        }
        .sb-ch:hover .sb-ch-ic { opacity: 0.8; }
        .sb-ch.active .sb-ch-ic { opacity: 1; }
        .sb-ch-txt { overflow: hidden; white-space: nowrap; }

        .sb-user {
          padding: 12px 12px 14px;
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-top: auto;
          background: rgba(0, 0, 0, 0.2);
          border-top: 1px solid rgba(255, 255, 255, 0.06);
        }
        .sb-user-row {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 4px;
          overflow: hidden;
        }
        .sb-avatar {
          width: 34px;
          height: 34px;
          border-radius: 8px;
          background: linear-gradient(135deg, #2563eb 0%, #7c3aed 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 12px;
          font-weight: 700;
          flex-shrink: 0;
        }
        .sb-user-txt {
          display: flex;
          flex-direction: column;
          overflow: hidden;
          white-space: nowrap;
          gap: 1px;
        }
        .sb-user-name { font-size: 12.5px; font-weight: 600; color: #e2e8f0; }
        .sb-user-role { font-size: 10.5px; color: #64748b; font-weight: 500; }
        
        .sb-actions {
          display: flex;
          gap: 5px;
        }
        .sb-act {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 5px;
          padding: 7px 4px;
          border-radius: 6px;
          border: 1px solid rgba(255, 255, 255, 0.06);
          background: rgba(255, 255, 255, 0.03);
          color: #94a3b8;
          cursor: pointer;
          font-size: 10.5px;
          font-weight: 500;
          font-family: inherit;
          transition: all 0.2s;
        }
        .sb-act:hover {
          background: rgba(255, 255, 255, 0.08);
          color: #e2e8f0;
        }
        .sb-act.out:hover {
          background: rgba(239, 68, 68, 0.1);
          color: #fca5a5;
        }

        .sb.collapsed .sb-brand { padding: 12px; justify-content: center; border-bottom: none; }
        .sb.collapsed .sb-logo-img { width: 34px; height: 34px; }
        .sb.collapsed .sb-brand-info,
        .sb.collapsed .sb-brand-fullname,
        .sb.collapsed .sb-brand-tagline,
        .sb.collapsed .sb-lnk-txt,
        .sb.collapsed .sb-sec-txt,
        .sb.collapsed .sb-sec-chev,
        .sb.collapsed .sb-ch-txt,
        .sb.collapsed .sb-ch,
        .sb.collapsed .sb-sec-body,
        .sb.collapsed .sb-user-txt,
        .sb.collapsed .sb-act span,
        .sb.collapsed .sb-sec-hdr:not(.c-mode) {
          display: none !important;
        }
        .sb.collapsed .sb-lnk {
          justify-content: center;
          padding: 10px;
          margin: 2px 6px;
        }
        .sb.collapsed .sb-sec-hdr.c-mode {
          justify-content: center;
          padding: 10px;
          margin: 2px 6px;
          border-radius: 8px;
          color: #64748b;
        }
        .sb.collapsed .sb-sec-hdr.c-mode:hover { background: rgba(255, 255, 255, 0.06); color: #94a3b8; }
        .sb.collapsed .sb-user { padding: 12px 8px; }
        .sb.collapsed .sb-user-row { justify-content: center; }
        .sb.collapsed .sb-actions { flex-direction: column; gap: 4px; }
        .sb.collapsed .sb-act { padding: 8px; }

        .sb.collapsed .sb-lnk:hover::after,
        .sb.collapsed .sb-sec-hdr.c-mode:hover::after,
        .sb.collapsed .sb-logo-img:hover::after {
          content: attr(data-tip);
          position: absolute;
          left: calc(100% + 12px);
          top: 50%;
          transform: translateY(-50%);
          background: #1e293b;
          color: #f1f5f9;
          padding: 6px 12px;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 500;
          white-space: nowrap;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
          border: 1px solid rgba(255, 255, 255, 0.1);
          z-index: 200;
          pointer-events: none;
        }

        @media (max-width: 768px) {
          .sb {
            width: 260px !important;
            transform: translateX(-100%);
            transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .sb.mob { 
            transform: translateX(0) !important; 
            box-shadow: 8px 0 32px rgba(0, 0, 0, 0.4);
          }
          .sb-close { display: flex; }
          .sb.collapsed .sb-brand-info,
          .sb.collapsed .sb-brand-fullname,
          .sb.collapsed .sb-brand-tagline,
          .sb.collapsed .sb-lnk-txt,
          .sb.collapsed .sb-sec-txt,
          .sb.collapsed .sb-sec-chev,
          .sb.collapsed .sb-ch-txt,
          .sb.collapsed .sb-ch,
          .sb.collapsed .sb-sec-body,
          .sb.collapsed .sb-user-txt,
          .sb.collapsed .sb-act span,
          .sb.collapsed .sb-sec-hdr.c-mode {
            display: flex !important;
          }
          .sb.collapsed .sb-sec-txt,
          .sb.collapsed .sb-lnk-txt,
          .sb.collapsed .sb-ch-txt,
          .sb.collapsed .sb-act span { display: block !important; }
          .sb.collapsed .sb-brand { padding: 16px; justify-content: flex-start; }
          .sb.collapsed .sb-logo-img { width: 40px; height: 40px; }
          .sb.collapsed .sb-lnk,
          .sb.collapsed .sb-sec-hdr.c-mode {
            justify-content: flex-start;
            padding: 7px 12px;
            margin: 1px 0;
          }
          .sb.collapsed .sb-sec-body.shut { max-height: 0 !important; }
          .sb.collapsed .sb-lnk:hover::after,
          .sb.collapsed .sb-sec-hdr.c-mode:hover::after { display: none; }
        }

        .sb-load {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 48px 24px;
          gap: 16px;
        }
        .sb-spin {
          width: 24px;
          height: 24px;
          border: 2.5px solid rgba(255, 255, 255, 0.08);
          border-top-color: #2563eb;
          border-radius: 50%;
          animation: sbSpin 0.8s linear infinite;
        }
        .sb-load-txt { font-size: 12px; color: #64748b; font-weight: 500; }
        @keyframes sbSpin { to { transform: rotate(360deg); } }

        .sb-ov {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.5);
          backdrop-filter: blur(4px);
          z-index: 90;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .sb-ov.active { opacity: 1; }
      `}</style>

      <aside className={`sb ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mob' : ''}`}>
        {/* BRAND HEADER */}
        <div className="sb-brand">
          <img 
            src={COMPANY_CONFIG.logoUrl}
            alt={COMPANY_CONFIG.fullName}
            className="sb-logo-img"
            data-tip={collapsed ? COMPANY_CONFIG.fullName : undefined}
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.insertAdjacentHTML('afterend', `
                <div style="width: 40px; height: 40px; border-radius: 10px; background: linear-gradient(135deg, #1e40af 0%, #2563eb 50%, #3b82f6 100%); display: flex; align-items: center; justify-content: center; font-size: 18px; font-weight: 800; color: white; flex-shrink: 0;">FB</div>
              `);
            }}
          />
          
          {!collapsed && (
            <div className="sb-brand-info">
              <div className="sb-brand-name">{COMPANY_CONFIG.name}</div>
              <div className="sb-brand-fullname">{COMPANY_CONFIG.fullName}</div>
              <div className="sb-brand-tagline">{COMPANY_CONFIG.tagline}</div>
            </div>
          )}

          <button className="sb-close" onClick={onCloseMobile} aria-label="Close sidebar">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* NAVIGATION */}
        <nav className="sb-nav">
          {loading || !user?.role?.permissions ? (
            <div className="sb-load">
              <div className="sb-spin" />
              <span className="sb-load-txt">Loading menu...</span>
            </div>
          ) : (
            <>
              {menuConfig.standalone
                .filter(i => !i.module || hasPermission(i.module, 'view'))
                .map(item => (
                  <NavLink
                    to={item.path}
                    key={item.path}
                    end={item.path === '/'}
                    className={({ isActive }) => `sb-lnk ${isActive ? 'active' : ''}`}
                    data-tip={collapsed ? item.label : undefined}
                    onClick={onCloseMobile}
                  >
                    <span className="sb-lnk-ic">{item.icon}</span>
                    <span className="sb-lnk-txt">{item.label}</span>
                  </NavLink>
                ))}

              {menuConfig.sections
                .filter(isSectionVisible)
                .map(section => {
                  const isOpen = !!openSections[section.id];
                  const items = getPermittedItems(section);
                  if (!items.length) return null;

                  return (
                    <div className="sb-sec" key={section.id}>
                      <button
                        className={`sb-sec-hdr ${isOpen ? 'open' : ''} ${collapsed ? 'c-mode' : ''}`}
                        onClick={() => !collapsed && toggleSection(section.id)}
                        data-tip={collapsed ? section.label : undefined}
                      >
                        <span className="sb-sec-ic">{section.icon}</span>
                        <span className="sb-sec-txt">{section.label}</span>
                        <span className="sb-sec-chev"><ChevronIcon open={isOpen} /></span>
                      </button>

                      <div
                        ref={el => { contentRefs.current[section.id] = el; }}
                        className={`sb-sec-body ${isOpen ? '' : 'shut'}`}
                        style={isOpen ? { maxHeight: contentRefs.current[section.id]?.scrollHeight + 16 || 400 } : undefined}
                      >
                        <div className="sb-sec-inner">
                          {items.map(item => (
                            <NavLink
                              to={item.path}
                              key={item.path}
                              end={item.path === '/'}
                              className={({ isActive }) => `sb-ch ${isActive ? 'active' : ''}`}
                              onClick={onCloseMobile}
                            >
                              <span className="sb-ch-ic">{item.icon}</span>
                              <span className="sb-ch-txt">{item.label}</span>
                            </NavLink>
                          ))}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </>
          )}
        </nav>

        {/* USER PANEL */}
        <div className="sb-user">
          <div className="sb-user-row">
            <div className="sb-avatar">
              {user?.firstName?.[0]}{user?.lastName?.[0]}
            </div>
            {!collapsed && (
              <div className="sb-user-txt">
                <span className="sb-user-name">{user?.firstName} {user?.lastName}</span>
                <span className="sb-user-role">{user?.role?.name}</span>
              </div>
            )}
          </div>
          <div className="sb-actions">
            <button className="sb-act" onClick={onToggleCollapsed} title={collapsed ? 'Expand' : 'Collapse'}>
              <CollapseIcon collapsed={collapsed} />
              {!collapsed && <span>Collapse</span>}
            </button>
            <button className="sb-act" onClick={goToProfile} title="My Profile">
              {ic.profile}
              {!collapsed && <span>Profile</span>}
            </button>
            <button className="sb-act out" onClick={logout} title="Sign out">
              {ic.logout}
              {!collapsed && <span>Logout</span>}
            </button>
          </div>
        </div>
      </aside>

      {mobileOpen && <div className="sb-ov active" onClick={onCloseMobile} />}
    </>
  );
}